import urls from "../global/constants/UrlConstants";
import { getCallParams, makeCall } from "../utils/service";

const base = urls.url_prod;

export async function listGrades(query: Record<string, any> = {}) {
  const qs = new URLSearchParams(
    Object.entries(query)
      .filter(([, v]) => v != null && v !== "")
      .map(([k, v]) => [k, String(v)])
  ).toString();
  const callParams = await getCallParams("GET");
  return makeCall(`${base}/grades${qs ? `?${qs}` : ""}`, callParams);
}

export async function createGrade(body: {
  name: string;
  description?: string;
  sortOrder?: number;
  status?: string;
}) {
  const callParams = await getCallParams("POST", body);
  return makeCall(`${base}/grades`, callParams);
}

export async function updateGrade(
  id: string,
  body: Record<string, any>
) {
  const callParams = await getCallParams("PUT", body);
  return makeCall(`${base}/grades/${id}`, callParams);
}

export async function deleteGrade(id: string) {
  const callParams = await getCallParams("DELETE");
  return makeCall(`${base}/grades/${id}`, callParams);
}
